import Vue from 'vue';
import loadingManager from '@/util/loading';
import axios from '@/util/axios';
import { baseURL } from '@/util/axios';
import { Toast } from 'mint-ui';

// const baseURLCommon = baseURL;

// console.log('baseURL', baseURLCommon);

export default {
    axiosCall(method, url, config={}) {
        return new Promise((resolve, reject) => {
            config.method = method;
            config.url = url;

            axios(config)
                    .then((res) => {
                        if(res.success) {
                            if(res.result === 0 || res.result === false) {
                                resolve(res.result);
                            }
                            else {
                                resolve(res.result || {}); //result有可能为null
                            }
                        }
                        else if(res.status == '200' && !res.result && typeof(res.data) == 'object'){
                            resolve(res);
                        }
                        else{
                            Toast(res.message || '');
                            reject(res.message || '');
                        }
                    }, (err) => {
                        Toast('系统错误，请稍后重试');
                        reject(err);
                    });   
                    
        });
    },

    handleUploading(event, file, fileList) {
        loadingManager.add({});
    },

    handleUploadResult(res) {
        if(res.success) {
            Toast(res.message);
        }
        else{
            Toast(res);
        }

        loadingManager.removAll();
    },

    getBaseURL() {
        return baseURL;
    },

    get(url, params, config={}) {
        config.params = params;
        return this.axiosCall('get', url, config);
    },

    post(url, data, config={}) {
        config.data = data;
        return this.axiosCall('post', url, config);
    },

    put(url, data, config={}) {
        config.data = data;
        return this.axiosCall('put', url, config);
    },

    delete(url, params, config={}) {
        config.params = params;
        return this.axiosCall('delete', url, config);
    },
}


// WEBPACK FOOTER //
// ./src/api/common.js